module.exports = {"loading":"Please wait..."};